define('controller',['lib/event-emitter', 'ajax-loader', 'session', 'strings'],
function(EventEmitter, ajaxLoader, session, strings) {
	var currentPage = $('body').data('page');
	var unconditionalCallbacks = [];
	var loadCallbacks = {};
	var unloadCallbacks = {};
	var disableAjaxLoading = false;
	
	function initLinks(context) {
		context.find('a').click(function(e) {
			if (disableAjaxLoading)
				return;
			
			// if a differend handler already disabled this link, to not follow it
			if (e.isDefaultPrevented() || $(this).data('no-instant'))
				return;
			
			// not left mouse button?
			if (e.button != 0)
				return;

			// strg + click?
			if (e.ctrlKey)
				return;
			
			// simple hash link?
			var hrefAttr = $(this).attr('href');
			if (hrefAttr.length > 0 && hrefAttr[0] == '#')
				return;

			if (this.hasAttribute('target')) {
				return;
			}

			// absolute, external link?
			if (this.href.indexOf(':') >= 0 && !strings.startsWith(this.href, location.protocol + '//' + location.host + '/')) {
				return;
			}
			
			e.preventDefault();			
			ajaxLoader.navigateTo(this.href);
		});
	}
	
	ajaxLoader.on('loading', function() {
		if (currentPage in unloadCallbacks) {
			unloadCallbacks[currentPage].forEach(function(handler) {
				handler();
			});
		}
	});
	
	ajaxLoader.on('loaded', function(newPageID) {
		initLinks($('#page'));
		
		// call handlers
		unconditionalCallbacks.forEach(function(handler) {
			handler();
		});
		if (newPageID in loadCallbacks) {
			loadCallbacks[newPageID].forEach(function(handler) {
				handler();
			});
		}
		currentPage = newPageID;
	});
	
	initLinks($('body'));
	
	return {
		on: function(pages, loadCallback, unloadCallback) {
			if (pages instanceof Function) {
				loadCallback = pages;
				loadCallback();
				unconditionalCallbacks.push(loadCallback);
			} else {
				if (!(pages instanceof Array))
					pages = [pages];
				
				if (pages.indexOf(currentPage) >= 0 && loadCallback)
					loadCallback();
				
				pages.forEach(function(pageName) {
					if (!(pageName in loadCallbacks))
						loadCallbacks[pageName] = [];
					loadCallbacks[pageName].push(loadCallback);
					
					if (unloadCallback) {
						if (!(pageName in unloadCallbacks))
							unloadCallbacks[pageName] = [];
						unloadCallbacks[pageName].push(unloadCallback)
					}
				});
			}
		},
		onNavigation: function(callback) {
			unconditionalCallbacks.push(callback);
		},
		disableAjaxLoading: function() {
			disableAjaxLoading = true;
		},
		navigateTo: function(href) {
			ajaxLoader.navigateTo(href);
		},
		setTitlePrefix: function(prefix) {
			if (prefix)
				prefix = prefix.trim() + ' ';
			document.title = prefix + ajaxLoader.title;
		}
	};
});

